<template>
  <div>
    <GradeCreate
      :createDialog="gradeCreateDialog"
      @close="gradeCreateDialog = false"
      :selectedYear="selectedYear">
    </GradeCreate>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title class="text.center">Add New Grades</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$router.go(-1)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container grid-list-md pb-0>
      <v-card outlined class="rounded-lg mt-5">
        <v-card-text>
          <v-layout row wrap>
            <v-flex class="text-h6">Select Year</v-flex>
          </v-layout>
          <v-list v-if="years" class="view-container" :dense="$vuetify.breakpoint.xsOnly">
            <template v-for="(item, index) in years">
              <v-list-item @click="openGradeDetails(item)" :key="item.name">
                <v-list-item-content>
                  <v-list-item-title class="text-capitalize">
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index < years.length - 1" :key="index"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-container>
    <BottomNavigation />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import yearService from "@/modules/Year/service.js";
import BottomNavigation from "@/modules/Layout/components/BottomNavigation.vue";
const GradeCreate = () => import("@/modules/Grades/Create.vue")
export default {
  name: "year-list",
  data() {
    return {
      selectedYear: null,
      years: [],
      gradeCreateDialog: false
    };
  },
  created() {
    if (!this.getClassRoom) {
      this.$router.push({ path: '/' })
    } else {
      this.getList();
      document.title = "taleem - Year List";
    }
  },
  components: {
    BottomNavigation,
    GradeCreate
  },
  computed: {
    ...mapGetters("teacherLayout", ["getClassRoom"]),
  },
  methods: {
    getList() {
      if(this.getClassRoom.ClassRoom && this.getClassRoom.ClassRoom.ClassId){
        return yearService.getAll({ClassId: this.getClassRoom.ClassRoom.ClassId}).then((response) => {
          console.log('response', response)
          this.loading = false;
          this.years = response.data;
          return response;
        }).catch(error => {
          console.log('error getting year', error)
        });
      }
    },
    openGradeDetails(year){
      this.selectedYear = year
      this.gradeCreateDialog = !this.gradeCreateDialog
    }
  },
};
</script>